import 'mobx-localstorage';
import 'intl';
import 'whatwg-fetch';
import './theme/fonts/campton';

import * as React from 'react';
import { render } from 'react-dom';
import { browserHistory } from 'react-router';
import { createRoutes } from './routes';

import { ClientModel } from './modules/client/model';
import { ClientController } from './modules/client/controller';
import { ClientView } from './modules/client/view';
import { syncHistoryWithStore } from 'mobx-react-router';
import { setupGlobalCSS } from './lib/styles';
import {setStylesTarget} from 'typestyle';
import {BLOGOSPHERE_URL, JAACKMAATE_URL, SIGNIN_URL, VIDSUMMIT_URL, VIDCON_URL, FULLSCREEN_URL} from './constants';
import completeSignin from './lib/completeSignin';
import setJaackMaateCampaign from './lib/setJaackMaateCampaign';
import setVidsummitCampaign from "./lib/setVidsummitCampaign";
import setBlogosphereCampaign from "./lib/setBlogosphereCampaign";
import setVidconCampaign from "./lib/setVidconCampaign";

let es6 = false;

async function run() {
  const model = new ClientModel();
  model.env.es6 = es6;

  const controller = new ClientController(model);
  /** Bail out early of running the frontend if we're signing in only */
  if (document.location.pathname.startsWith(SIGNIN_URL))
    await completeSignin(controller);

  /** Bail out early of running the frontend if we're JaackMaate campaign */
  if (document.location.pathname.startsWith(JAACKMAATE_URL))
    return setJaackMaateCampaign();

  /** Bail out early of running the frontend if we're Vidsummit campaign */
  if (document.location.pathname.startsWith(VIDSUMMIT_URL))
    return setVidsummitCampaign();

  /** Bail out early of running the frontend if we're Blogosphere campaign */
  if (document.location.pathname.startsWith(BLOGOSPHERE_URL))
    return setBlogosphereCampaign();

  /** Bail out early of running the frontend if we're Vidcon campaign */
  if (document.location.pathname.startsWith(VIDCON_URL))
    return setVidconCampaign();

  const history = syncHistoryWithStore(browserHistory, model.router) as any;
  const routes = createRoutes(controller, model);
  const routerProps = { history, routes };

  if (!model.env.isServer) controller.analytics.init();

  setupGlobalCSS();

  render(
    <ClientView model={model} controller={controller} routerProps={routerProps} />,
    document.getElementById('root'),
  );
  setStylesTarget(document.getElementById('styles-target'));
}

const promises = [];

if (!global.Intl) {
  promises.push(System.import('./lib/intl-shim.ts'));
}

const test = 'class Foo { constructor(a = "a") { const b = a; } }';

try {
  eval(test);
  es6 = true;
} catch(e) {}

Promise.all(promises).then(() => run());